import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { addHours, endOfDay, isAfter, max, isBefore, startOfDay, startOfHour, subHours } from "date-fns";
import Fade from "@mui/material/Fade";
import { dateFromState } from "../../../Helpers/DateTimeHelper";
import RestoreIcon from "@mui/icons-material/Restore";
import { getDefaultAvailabilitySlot } from "../../../Common/Availability/Availability";
import Tooltip from "@mui/material/Tooltip";

const AvailabilityTimelineDateSwitcher = (props) => {

    const [errorMessage, setErrorMessage] = useState(null);

    // Create a local copy of the error message so we can
    // slowly fade out the previous message when the error is cleared
    useEffect(() => {
        if (props.errorMessage) {
            setErrorMessage(props.errorMessage);
        }
    }, [props.errorMessage]);

    const handleNextDateClick = (e) => {
        props.onBookingDateChange(
            addHours(dateFromState(props.timelineDate), props.hoursPerPage)
        );
    }

    const handlePreviousDateClick = (e) => {
        props.onBookingDateChange(
            subHours(dateFromState(props.timelineDate), props.hoursPerPage)
        );
    }

    /**
     * Do not show the previous date button if clicking that button
     * would take the start of the timeline before the start of the
     * current day
     * @returns {boolean}
     */
    const shouldShowPreviousDateButton = () => {
        let checkDate = subHours(dateFromState(props.timelineDate), (props.hoursPerPage));
        return !isBefore(
            checkDate,
            startOfDay(new Date())
        );
    }

    function shouldShowResetDateButton () {
        if (!props.selectedInterval) {
            return false;
        }

        return isAfter(
            dateFromState(props.timelineDate),
            dateFromState(props.selectedInterval.end),
        )
    }

    const shouldShowErrorMessage = () => {
        if (props.isLoading) {
            return false;
        }
        return (!!props.errorMessage);
    }

    return (
        <div className="grid-x timeline-date-switcher">
            <div className="small-2">
                { shouldShowPreviousDateButton() &&
                    <button
                        type="button"
                        onClick={handlePreviousDateClick}
                        className="button primary small margin-bottom-0"
                    >
                        <i className="fa fa-chevron-left" />
                    </button>
                }
                { shouldShowResetDateButton() &&
                    <Tooltip title="Back to selection">
                        <button
                            type="button"
                            onClick={props.onResetDateClick}
                            className="button primary small mui-icon margin-bottom-0 margin-left-half"
                        >
                            <RestoreIcon fontSize="small"/>
                        </button>
                    </Tooltip>
                }

            </div>
            <div className="small-8">
                <Fade in={shouldShowErrorMessage()}>
                    <small
                        className="error text-center"
                        style={{display: 'inline-block', width:'100%'}}
                    >
                        {errorMessage}
                    </small>
                </Fade>
            </div>
            <div className="small-2 text-right">
                <button
                    type="button"
                    onClick={handleNextDateClick}
                    className="button primary small margin-bottom-0"
                >
                    <i className="fa fa-chevron-right" />
                </button>
            </div>
        </div>
    );
}

AvailabilityTimelineDateSwitcher.propTypes = {
    date: PropTypes.any,
    errorMessage: PropTypes.string,
    hoursPerPage: PropTypes.number,
}

AvailabilityTimelineDateSwitcher.defaultProps = {
    
}

export default AvailabilityTimelineDateSwitcher;
